module.exports = __webpack_public_path__ + "static/media/agronesia.b2362e8f.png";